import type { UserProfile } from "../../shared/contracts";

export function profileSharePath(profile: Pick<UserProfile, "id" | "role" | "profileShareToken">): string {
  return profile.role === "seller"
    ? `/share/profiles/${profile.profileShareToken}`
    : `/seller/${profile.id}`;
}
